// extracted by mini-css-extract-plugin
export var infoItem = "_q5-2";
export var title = "_q5-0";
export var value = "_q5-1";